var exports = {
  "kL": "x93eb46d8--9b8144--container",
  "hm": "x93eb46d8--9b8144--middle-indent",
  "Tv": "x93eb46d8--9b8144--large-indent",
};

module.exports = exports;
